import { render } from "./LocalUsersDetail.vue?vue&type=template&id=4b8dd270&ts=true"
import script from "./LocalUsersDetail.vue?vue&type=script&lang=ts"
export * from "./LocalUsersDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__